<template lang="pug">
  .row-content.d-flex.align-center.headAggregatorPromotions.cursor-pointer(@click="$emit('click')")
    v-col.colImgAggregator(cols="2")
      img(v-if="firstPromo || isCompetitor" :src="getImageAggregator(deliveryPlatform)")
    v-col.d-flex.justify-space-between(cols="10" v-if="menuItems.length > 0")
      div
        span.labelPromo #[translate PROMOTION]
        span.countPromoRestaurant &nbsp; #[translate In] {{ maxCenters }} #[translate restaurants]
        br
        strong.namePromo
          span(v-if="promo !== ''") "{{ promo }}"
      div(v-if="menuItems.length >= 2")
        v-icon(v-if="isCollapse") mdi-chevron-down
        v-icon(v-else) mdi-chevron-up
    v-col.withOutPromo(cols="10" v-else)
      span #[translate No promotions]
</template>

<script>
export default {
  name: 'PromoAggregatorHeader',
  props: {
    deliveryPlatform: {
      type: String,
      default: ""
    },
    firstPromo: {
      type: Boolean,
      default: false
    },
    isCollapse: {
      type: Boolean,
      default: true
    },
    maxCenters: {
      type: Number,
      default: 0
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    promo: {
      type: String,
      default: ""
    },
    isCompetitor: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getImageAggregator(aggregator){
      let aggregatorLoweCase = aggregator.toLowerCase()
      if(aggregatorLoweCase === 'deliveroo'){
        return require("@/assets/img/aggregators/Deliveroo.png")
      } else if (aggregatorLoweCase === "glovo"){
        return require("@/assets/img/aggregators/Glovo.png")
      } else if (aggregatorLoweCase === "just eat"){
        return require("@/assets/img/aggregators/Just Eat.png")
      } else if (aggregatorLoweCase === "uber eats"){
        return require("@/assets/img/aggregators/Uber Eats.png")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.headAggregatorPromotions{
  background-color: #E4E7EB;
  .labelPromo{
    font-size: 10px;
    font-weight: 300;
  }
  .countPromoRestaurant{
    font-size: 11px;
  }
  .namePromo{
    font-size: 0.813rem;
  }
  .col-10{
  border-left: 5px solid #fff;

  }
}
.withOutPromo{
  font-size: 10px;
  color:#4A4A4A;
}
</style>
